import { NgModule } from '@angular/core';
import { AuthGuard, provideConfig, provideDefaultConfig, RoutingConfig } from '@spartacus/core';
import { translationChunksConfig } from '@spartacus/assets';
import { RouterModule, Routes } from '@angular/router';
import { CmsPageGuard } from '@spartacus/storefront';

const routes: Routes = [
  {
    data: {
      cxRoute: 'transactionDetails'
    },
    canActivate: [AuthGuard, CmsPageGuard],
    path: null,
    loadComponent: () =>
      import('./transaction-details-page/transaction-details-page.component').then(m => m.TransactionDetailsPageComponent)
  },
  {
    data: {
      cxRoute: 'reports'
    },
    canActivate: [AuthGuard, CmsPageGuard],
    path: null,
    loadComponent: () => import('./reports-page/reports-page.component').then(m => m.ReportsPageComponent)
  }
];

@NgModule({
  declarations: [],
  exports: [RouterModule],
  imports: [
    RouterModule.forChild(routes),
  ],
  providers: [
    provideDefaultConfig({
      routing: {
        routes: {
          transactionDetails: {
            paths: ['my-account/transaction-details/:transactionId'],
            paramsMapping: { transactionId: 'transactionId' },
          },
          reports: {
            paths: ['my-account/reports'],
          }
        },
      },
    } as RoutingConfig),
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class ReportsModule {
}
